import React from 'react'

export const TermsConditionInfo = () => {
  return (
    <>
      <section className='section-padding'>
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <div className="terms-condition-content">
                <h1 className='mb-5'>Terms & Conditions</h1>

                <h5>1. General</h5>
                <p className='mb-4'>These Terms & Conditions apply to all services provided by OFL Logistics Pty Ltd unless otherwise agreed in writing. By engaging our services, you agree to be bound by these terms.</p>

                <h5>2. Services</h5>
                <p className='mb-4'>The Company provides logistics, transport, warehousing and related services with reasonable care and skill. Delivery and service times are estimates only and are not guaranteed.</p>

                <h5>3. Charges and Variations</h5>
                <p className='mb-4'>All rates are subject to change without notice. Charges may vary due to fuel levy fluctuations, port charges, labour requirements, waiting time, detention, or other third-party costs.</p>

                <h5>4. Payment Terms</h5>
                <p className='mb-4'>Invoices are payable within agreed terms. The Company reserves the right to suspend services for overdue accounts and charge interest or recovery costs where applicable.</p>

                <h5>5. Customer Responsibilities</h5>
                <p className='mb-4'>The Customer must provide accurate instructions, proper packaging, and comply with all laws and regulations. The Company is not responsible for issues arising from incorrect or incomplete information.</p>

                <h5>6. Liability</h5>
                <p className='mb-4'>To the extent permitted by law, the Company's liability is limited to the resupply of services or the cost of resupply. The Company is not liable for indirect, consequential or economic loss.</p>

                <h5>7. Storage and Handling</h5>
                <p className='mb-4'>Goods stored or handled are at the Customer's risk unless otherwise agreed. Additional charges may apply for manual handling, palletising, or special requirements.</p>

                <h5>8. Claims</h5>
                <p className='mb-4'>Any claims must be submitted in writing within 7 days of delivery or service completion. Failure to do so may result in the claim being declined.</p>

                <h5>9. Force Majeure</h5>
                <p className='mb-4'>The Company is not liable for any failure or delay due to events beyond its reasonable control, including port congestion, weather, industrial action or system failures.</p>

                <h5>10. Governing Law</h5>
                <p className='mb-4'>These Terms are governed by the laws of Australia.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}